<template>
  <div class="p-6 bg-white rounded-lg">
    <div class="flex items-center mb-4 pb-4 border-b">
      <div
        class="w-12 h-12 rounded-lg text-white p-1 bg-primary"
      >
        <icon name="staff" />
      </div>
      <h3 class="text-2xl font-medium ml-4">
        Learning Platform
      </h3>
    </div>
    <a class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase"
       target="_blank" :href="nurturSamlUrl" >
      Login
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['module'],

  computed: {
    ...mapState(['profile']),
    nurturSamlUrl () {
      return process.env.VUE_APP_ROOT_API + '/sso/login-nurtur?access_token=' + localStorage.getItem('accessToken')
    }
  }
}
</script>
